exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit-box[data-v-5dfc9c5d] {\n  position: relative;\n  text-align: left;\n}\n.edit-button[data-v-5dfc9c5d] {\n  position: absolute;\n  top: calc(50% - 14px);\n  right: 3%;\n  width: 100px;\n  text-align: right;\n}\n.edit-input[data-v-5dfc9c5d] {\n  width: 70%;\n  text-align: left;\n}\n", ""]);

// exports
